var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGzRobbery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 56.67V65H58.4l7-14.59a6.55 6.55 0 014.6 6.26zM60 44l-3 6H39a6.88 6.88 0 00-7 6.73V65h17.75l-3.85 8H49l12.85-26H70v-3H60zm-17-5.43a8 8 0 1016 0 8 8 0 00-16 0zm-3.27 4.12c-.2-.55-.358-1.115-.47-1.69H28.83v-8H23v8H10V21.74l15.84-11.29L42 21.75v8.92a12.257 12.257 0 011.59-1.55A11.822 11.822 0 0146 27.66v-8L25.82 5.55 6 19.68v25.26h34.85a10.709 10.709 0 01-1.12-2.25zm-3.9-15.75V21H30v5.92l5.83.02zm-14 0V21H16v5.92l5.83.02z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/GZ_Robbery.69ae9e23.svg";
export { SvgGzRobbery as ReactComponent };